module.exports = __webpack_public_path__ + "static/media/S1N6-6.f858cc6d.svg";